// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"176":"projects","177":"home","597":"resume","631":"contact"}[chunkId] + "." + {"176":"25718096","177":"27ef387b","597":"da423348","631":"cf6bfea1"}[chunkId] + ".css";
};